import { FC, ReactNode } from "react";
import { adminInputInlineClass } from "../../admin/adminStyles";

interface SelectWithLabelProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  required?: boolean;
  hint?: string;
  children: ReactNode;
  id?: string;
}

const SelectWithLabel: FC<SelectWithLabelProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  hint,
  children,
  id,
}) => (
  <div className="space-y-2">
    <label htmlFor={id || name} className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {label}
      {required && <span className="ml-1 text-red-500">*</span>}
    </label>
    <select
      id={id || name}
      name={name}
      value={value}
      onChange={onChange}
      className={`${adminInputInlineClass} h-11`}
    >
      {children}
    </select>
    {hint && <p className="text-xs text-gray-500 dark:text-gray-400">{hint}</p>}
  </div>
);

export default SelectWithLabel;
